import { useLocation, Navigate, Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuth } from '@/context/AuthContext';

export default function Layout() {
  const location = useLocation();
  const { orgId, isAuthenticated, isLoading } = useAuth();
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';

  if (isAuthPage) {
    return <Outlet />;
  }

  // Сессия кончилась (или её не было) — на страницу входа, а не пустые экраны
  // с «Not authenticated» под видом залогиненного пользователя.
  if (!isLoading && !isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Sidebar />
      <main className="ml-64 min-h-screen min-w-0">
        <div className="p-6 md:p-8 max-w-[1400px]">
          {/* key по организации: при её смене страница монтируется заново.
              Иначе выбранная вакансия/кандидат/портрет оставались от прежней
              организации — списки обновлялись, а открытая карточка нет. */}
          <Outlet key={orgId ?? 'no-org'} />
        </div>
      </main>
    </div>
  );
}